<template>
    <router-view/>
</template>
<script>
export default {
    name: 'FormaPagamentoRoute',
    
    beforeRouteUpdate(to, from, next) {
        if(to.name == 'des-forma-pagamento'){
            next({ name: 'des-forma-pagamento-list' })
        }else{
            next()
        }
    },
    created() {
        if(this.$route.name == 'des-forma-pagamento'){
            this.$router.push({ name: 'des-forma-pagamento-list' })
        }
    }
}
</script>
